import { getApi, postApi } from './Api';

export const getTemplate = async () => {
  const url = `/admin/kit/kitMeta/all`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getTemplateByName = async (id) => {
  const url = `/admin/kit/kitMeta/select/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getTemplateBySearch = async (name) => {
  const url = `/admin/kit/kitMeta/name/${name}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getTemplateHospital = async (id) => {
  const url = `/admin/kit/kitMeta/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getTemplateInfo = async () => {
  const url = `/admin/kit/kitMeta/info`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const saveTemplate = async (data) => {
  const url = `/admin/kit/kitMeta`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};
